module.exports = "a {\n    text-decoration: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/edicao-artefatos/edicao-artefatos-modal.component.css
// module id = ./src/app/modal/edicao-artefatos/edicao-artefatos-modal.component.css
// module chunks = main